/**
 * Resolves after `delayInMS` delay.
 * @param {number} delayInMS - delay in milliseconds
 */
export default function timeoutAsPromise(delayInMS = 0) {
    return new Promise(resolve => {
        setTimeout(resolve, delayInMS);
    });
}
